module.exports = __webpack_public_path__ + "img/Uruguay.cf84b95d.gif";